import { useSearchParams } from 'react-router-dom'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { getEmpresaClienteById } from '../../../empresasCliente-list/core/_request'
import { CoordenadorClienteModal } from '../modal/CoordenadorClienteModal'
import { useT } from '_metronic/i18n/Metronici18n'

export const CoordenadorClienteListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()
  const [searchParams] = useSearchParams()
  const clienteId = Number(searchParams.get('cliente'))

  const openAddCoordenador = () =>
    showModal({
      title: 'Cadastro Coordenador',
      content: <CoordenadorClienteModal />,
      size: ModalSize.Medium,
      fetchers: {
        cliente: () => getEmpresaClienteById(clienteId),
      },
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openAddCoordenador}>
      {t('common.add')}
    </Button>
  )
}
